import {
  AppBar,
  ButtonBase,
  IconButton,
  Toolbar,
  Typography,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import { FC, useState, useContext } from "react";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import { Store } from "../store";
import types from "../store/types";
import { useTranslation } from 'react-i18next';
import { basicColor } from "../common/colors";
import { useCustomMediaQuery } from "../common/useCustomMediaQuery";
import { useIsReadOnly } from "../hooks/useStoreGetters";

const getTitleStyle = (isDesktop: boolean) => {
  return {
    position: "absolute",
    top: isDesktop ? 10 : 5,
    left: isDesktop ? 10 : 5,
    fontWeight: "bold",
    color: "#2F5597",
    zIndex: -1,
    wordBreak: "break-all",
  } as const;
};

const getReadBoxStyle = (isDesktop: boolean) => {
  return isDesktop ? {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'absolute',
    left: '50%',
    transform: 'transformX(-50%)',
  } : {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  } as const;
};

const SpaceDiv = styled.div`
    flex-grow: 1;
`;

// 今日の日付を「年/月/日 (曜日英表記)」で取得する
const getTodayText = (): string => {
  const date = new Date();
  const year = date.getFullYear();
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const day = date.getDate().toString().padStart(2, '0');
  const days = ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"];
  const weekday = days[date.getDay()];
  return `${year}/${month}/${day} (${weekday})`;
};

const Appbar: FC = () => {
  const { t } = useTranslation();
  const { state, dispatch } = useContext(Store);
  const isReadOnly = useIsReadOnly();
  const navigate = useNavigate();
  const { isDesktop } = useCustomMediaQuery();
  const fontSize = isDesktop ? "1.25rem" : "0.8rem";

  const [open, setOpen] = useState<boolean>(false);

  const handleClickOpen = () => {
    dispatch({
      type: types.SET_READ_USER,
      payload: {
        readUser: null,
      },
    });
    setOpen(true);
  };

  const handleReload = () => {
    setOpen(false);
    window.location.reload();
  };

  return (
    <>
      <AppBar position="sticky" elevation={0} sx={{ background: basicColor }}>
        <Toolbar>
          <IconButton
            edge="start"
            className="test"
            color="inherit"
            aria-label="menu"
            onClick={() => {
              dispatch({ type: types.SIDEBAR_CLICK });
            }}
          >
            <MenuIcon />
          </IconButton>
          <ButtonBase>
            <Typography variant="h6"
              sx={{
                position: "relative",
                fontSize,
              }}
              onClick={() => { navigate("/home"); }}
            >
              {t("appbar.title")}
              <span style={getTitleStyle(isDesktop)}>Self-Design Learning</span>
            </Typography>
          </ButtonBase>
          <SpaceDiv></SpaceDiv>
          {isReadOnly ?
            <Box sx={getReadBoxStyle(isDesktop)}>
              <Typography sx={{
                fontSize,
                marginRight: '2px',
              }}>{t("appbar.readonly")}</Typography>
              <Button
                sx={{
                  backgroundColor: 'gray',
                  color: 'white',
                  '&:hover': {
                    backgroundColor: '#555555',
                  },
                  fontSize,
                  marginLeft: '5px',
                }}
                variant="contained"
                onClick={handleClickOpen}
              >
                {t("button.release")}
              </Button>
            </Box> : <></>}
          {isReadOnly && isDesktop == false
            ? <></>
            : <Typography variant="h6" sx={{ fontSize }}>{getTodayText()}</Typography>
          }
        </Toolbar>
      </AppBar>
      <Dialog
        open={open}
        onClose={handleReload}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {t("msg.release.title")}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {t("msg.release.body")}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleReload} autoFocus variant="contained">
            OK
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default Appbar;
